import { LOGOUT } from '../../app/authState'
import { getStateByAbbreviation } from '../../utils/common'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { GET_DRUG_RULES_SETTINGS_SUCCESS } from '../drugRulesSettings/drugRulesSettingsConstants'
import { GET_SERVICE_TYPES_SUCCESS_MEMBER } from '../member/MemberConstants'
import { SAVE_STATE_SETTINGS_SUCCESS } from '../state-settings/StateSettingsConstants'
import {
  CHANGE_SERVICE_ORDER,
  CHANGE_SERVICE_ORDER_ERROR,
  CHANGE_SERVICE_ORDER_SUCCESS,
  CHANGE_TABS,
  CHECK_API_ERROR,
  CHECK_API_SUCCESS,
  GET_SERVICE_TYPES,
  GET_SERVICE_TYPES_ERROR,
  GET_SERVICE_TYPES_SUCCESS,
  GET_STATES_SETTINGS,
  GET_STATES_SETTINGS_ERROR,
  GET_STATES_SETTINGS_SUCCESS,
  RESET_MANAGEMENT_ERROR,
  SET_LOADING,
} from './ManagementConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const normalizeVisitTypes = (serviceTypesList) =>
  serviceTypesList.reduce(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (serviceTypesNorm, serviceTypesValue) => {
      const visitTypes = serviceTypesValue.VisitTypes || []

      const VisitTypesNormalized = visitTypes.reduce(
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        (visitTypesNorm, visitTypesValue) => {
          visitTypesNorm.entities[visitTypesValue.VisitTypeId] = visitTypesValue
          visitTypesNorm.ids.push(visitTypesValue.VisitTypeId)

          return visitTypesNorm
        },
        { entities: {}, ids: [] },
      )

      serviceTypesNorm.entities[serviceTypesValue.ServiceTypeId] = {
        ...serviceTypesValue,
        VisitTypes: VisitTypesNormalized,
      }
      serviceTypesNorm.ids.push(serviceTypesValue.ServiceTypeId)

      return serviceTypesNorm
    },
    { entities: {}, ids: [] },
  )

const initialState = {
  loading: false,
  serviceTypes: [],
  statesSettings: { SettingsPerState: [] },
  error: '',
  tabs: [
    { name: 'Clinic members', isActive: true },
    { name: 'Service types', isActive: false },
    { name: 'Intake forms', isActive: false },
    { name: 'States', isActive: false },
  ],
  defaultServerErrorMessage: '',
  newSettingsPerState: {},
}

export default function managementReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case CHANGE_TABS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        tabs: state.tabs.map((t) => (t.name === action.payload ? { ...t, isActive: true } : { ...t, isActive: false })),
      }
    case CHANGE_SERVICE_ORDER:
      return {
        ...state,
        loading: true,
      }
    case GET_SERVICE_TYPES:
    case GET_STATES_SETTINGS:
      return {
        ...state,
        loading: true,
      }
    case GET_STATES_SETTINGS_SUCCESS:
    case GET_DRUG_RULES_SETTINGS_SUCCESS:
      // Maybe better to have backend send StateName
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const newPayload = action.payload.SettingsPerState.map((state) => {
        state.StateName = getStateByAbbreviation(state.StateCode)
        return state
      })
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      newPayload.sort((a, b) => a.StateName.localeCompare(b.StateName))
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      action.payload.SettingsPerState = newPayload
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        statesSettings: action.payload,
      }
    case SAVE_STATE_SETTINGS_SUCCESS:
      const updatedStateSettings = JSON.parse(JSON.stringify(state.statesSettings.SettingsPerState))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedStateSettings.forEach((setting, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (setting.StateCode === action.extraData.stateCode) {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedStateSettings[index] = { ...updatedStateSettings[index], ...action.extraData.settings }
        }
      })
      return {
        ...state,
        statesSettings: { SettingsPerState: updatedStateSettings },
      }
    case RESET_MANAGEMENT_ERROR: {
      return {
        ...state,
        error: '',
        defaultServerErrorMessage: '',
      }
    }
    case SET_LOADING:
      return {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: action.payload,
      }
    case GET_SERVICE_TYPES_ERROR:
    case GET_STATES_SETTINGS_ERROR:
      return {
        ...state,
        error: getUserFriendlyErrorMessage(errorCodes.DEFAULT),
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage: action.payload,
      }
    case GET_SERVICE_TYPES_SUCCESS:
    case GET_SERVICE_TYPES_SUCCESS_MEMBER:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        serviceTypes: [...action.payload],
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        normalizedServiceTypes: normalizeVisitTypes(action.payload),
        loading: false,
      }
    case CHANGE_SERVICE_ORDER_ERROR:
      return {
        ...state,
        error: getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION),
        loading: false,
      }
    case CHANGE_SERVICE_ORDER_SUCCESS:
    case CHECK_API_SUCCESS:
    case CHECK_API_ERROR:
      return {
        ...state,
        loading: false,
      }
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
